const toEmbedUrl = (url) => {
  const youtube = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/
  );

  if (youtube) {
    return `https://www.youtube.com/embed/${youtube[1]}?autoplay=1&rel=0`;
  }

  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);

  if (vimeo) {
    return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1`;
  }

  return url;
};

const createModal = () => {
  const modal = document.createElement('div');
  modal.className = 'case-video-modal';
  modal.hidden = true;
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', 'Video');
  modal.innerHTML = `
    <button class="case-video-modal__backdrop" type="button" data-case-video-close aria-label="Close video"></button>
    <div class="case-video-modal__dialog">
      <button class="case-video-modal__close" type="button" data-case-video-close aria-label="Close video">
        <span aria-hidden="true"></span>
      </button>
      <div class="case-video-modal__player" data-case-video-player></div>
    </div>
  `;
  document.body.appendChild(modal);

  return modal;
};

const initCaseStudyVideo = () => {
  let modal;
  let trigger;

  const close = () => {
    if (!modal || modal.hidden) {
      return;
    }

    modal.hidden = true;
    modal.querySelector('[data-case-video-player]').replaceChildren();
    document.body.classList.remove('has-open-modal');
    if (trigger) {
      trigger.focus();
    }
  };

  const open = (button) => {
    const url = button.dataset.caseVideo;
    const file = button.dataset.caseVideoFile;

    if (!url && !file) {
      return;
    }

    if (!modal) {
      modal = createModal();
    }
    trigger = button;

    let player;

    if (file) {
      player = document.createElement('video');
      player.src = file;
      player.controls = true;
      player.autoplay = true;
      player.playsInline = true;
    } else {
      player = document.createElement('iframe');
      player.src = toEmbedUrl(url);
      player.title = button.getAttribute('aria-label') || 'Video';
      player.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      player.setAttribute('allowfullscreen', '');
    }

    modal.querySelector('[data-case-video-player]').replaceChildren(player);
    modal.hidden = false;
    document.body.classList.add('has-open-modal');
    modal.querySelector('.case-video-modal__close').focus();
  };

  document.addEventListener('click', (event) => {
    const videoButton = event.target.closest(
      '[data-case-video], [data-case-video-file]'
    );

    if (videoButton) {
      open(videoButton);
      return;
    }

    if (event.target.closest('[data-case-video-close]')) {
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if ('Escape' === event.key) {
      close();
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCaseStudyVideo);
} else {
  initCaseStudyVideo();
}
